import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { SenderType } from "@/commons/models/Resident";
import { FamilyPermittedFunctions } from "./Families";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * 家族メールユーザー API 操作クラス
 */
export default class MailFamilies {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * POST Families
   */
  public async post(userStore: LoginUser, residentId: number, model: MailFamiliesPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      residentId: residentId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.MailFamilies, formatParams);

    const response = await this.commonService.executePost<any>(userStore, requestUrl, model, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * PATCH Families
   */
  public async patch(userStore: LoginUser, residentId: number, familyId: number, model: MailFamiliesPatchModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      residentId: residentId,
      familyId: familyId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.MailFamily, formatParams);

    const response = await this.commonService.executePatch<any>(userStore, requestUrl, model, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * DELETE Families
   */
  public async delete(userStore: LoginUser, residentId: number, familyId: number, requestBody?: MailFamiliesDeleteModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.facility.id,
      residentId: residentId,
      familyId: familyId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.MailFamily, formatParams);

    const response = await this.commonService.executeDelete<any>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0, requestBody);

    return response.data;
  }
}

export interface MailFamiliesPostModel {
  familyMailaddress: string;
  familyName: string;
  familyTel: string;
  familyRelation: string;
  familyPosition?: string;
  familyGender: string;
  familyBirthDay?: number;
}

export interface MailFamiliesPatchModel {
  familyMailaddress: string;
  familyName: string;
  familyTel: string;
  familyRelation: string;
  familyPosition?: string;
  familyGender: string;
  familyBirthDay?: number;
  familyPermittedFunctions: FamilyPermittedFunctions;
  senderType: SenderType;
  updated: number;
}

export interface MailFamiliesDeleteModel {
  concurrentDeleteFacilityIds: number[];
}
